import { render, staticRenderFns } from "./AccountsTree.vue?vue&type=template&id=c4068fcc&scoped=true"
import script from "./AccountsTree.vue?vue&type=script&lang=js"
export * from "./AccountsTree.vue?vue&type=script&lang=js"
import style0 from "./AccountsTree.vue?vue&type=style&index=0&id=c4068fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4068fcc",
  null
  
)

export default component.exports